// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.

var needPayload = {
  _this: this,
  customMsg: ()=> {
    var custom_msg = document.querySelectorAll('[data-country-msg]')

    if (custom_msg.length > 0) {
      custom_msg.forEach(e=> {
        var country_ico = e.dataset.country
    
        if ( currentCountry == country_ico) {
          var meg_item = e.querySelector('p')
          var message = e.dataset.countryMsg
    
          meg_item.innerHTML = message;
          console.log(country_ico)
    
          e.style.opacity = '1';
        }
      })
    }
  },
  freeShipPk: ()=> {

    var shippingBar = document.querySelectorAll('.free-shipping-bar')
    shippingBar.forEach(e=> {
  
          if (currentCountry == 'PK') {
            // document.querySelectorAll('a[data-value="PK"]')[0].click()
  
            var freeShipContent = `	<div class="inventory-counter__message-wrapper ff-body fs-body-75">
            <span class="icon icon-new icon-package-closed ">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.48 5.28 12 8.813 1.518 5.28M12 21.851V8.814" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10"></path>
              <path d="m7.025 3.425 10.48 3.535" stroke="currentColor" stroke-width="1.079" stroke-miterlimit="10"></path>
              <path d="m12 21.851 10.48-4.413V5.279L12 1.75 1.518 5.279v12.159L12 21.85z" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10"></path>
              <path d="m4.322 8.855 4.403 1.524v2.945L4.322 11.67V8.855z" stroke="currentColor" stroke-width="1.079" stroke-miterlimit="10"></path>
            </svg>
            </span>
            <h4 class="free-shipping-bar__message">Your order qualifies for free shipping!</h4>
          </div>
          <div class="free-shipping-bar__bar" style="--progress-width:100%;">
            <span class="free-shipping-bar__bar-progress"></span>
          </div>`;
            e.classList.add('free-shipping-bar--success');
            e.classList.add('free-shipping-pk');
            e.innerHTML = '';
            e.insertAdjacentHTML('afterbegin', freeShipContent);
          }
    })
  },
  customTab: ()=> {
    document.querySelectorAll('[data-active-country]').forEach(e=> {
      const countries = e.dataset.activeCountry.split(',');
      const content = e.dataset.countryMsg
      
      if (countries.includes(currentCountry)) {
        const wrapper = e.querySelector('.accordion__content')
        wrapper.innerHTML = content;
      }
    })
  },
  loadCountry: ()=> {
    fetch('https://api.ipregistry.co/?key=y2jzc6fwnvimlnhk')
    .then(function (response) {
        return response.json();
    }).then(function (payload) {
      console.log(payload)

      if (payload.code == 'INSUFFICIENT_CREDITS') return;

      currentCountry = payload.location.country.code;
      needPayload.customMsg()
      needPayload.freeShipPk()
      needPayload.customTab();
      // needPayload.codApp()
    })
  }
}

needPayload.loadCountry();

document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
  setTimeout( function() {
    console.log(document.querySelectorAll('.free-shipping-bar'))
    needPayload.freeShipPk()
  },1000)
}); // This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
  needPayload.freeShipPk()
}); // This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.

document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
  needPayload.freeShipPk()
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.

document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
}); // This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.

document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
}); // This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.

document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
}); // This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.

document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});




// if (typeof(_rsi.buyButton) != undefined &&  _rsi.buyButton != null ) {
//   document.querySelectorAll('#_rsi-buy-now-button')
// }


window.addEventListener('DOMContentLoaded', (event) => {
  document.querySelectorAll('.video-hero__video-wrapper video').forEach(e=> {
    e.play()
  })
});


window.addEventListener('DOMContentLoaded', (event) => {

  document.querySelectorAll('.video-hero__video-wrapper video').forEach(e=> {
    e.play()
  })

  document.querySelectorAll('a[href*="#kl_"]').forEach(el=> {
    el.addEventListener('click', function (e) {

      e.preventDefault();
      var formid = e.currentTarget.href.split('#');
      formid = formid[formid.length - 1]
      var filtFormId = formid.replace('kl_','').toString();

      console.log(filtFormId)
      window._klOnsite = window._klOnsite || []; 
      window._klOnsite.push(['openForm', filtFormId]);
      // _klOnsite.openForm(formid)
    });
  })
});

// function CartRecom() {
//   if ( document.querySelector('.cart-recommendations') != null) {
//     var cartRecomWrapper = document.querySelector('.cart-recommendations');

//     var requestUrl = "".concat(window.theme.routes.productRecommendations, "?section_id=").concat('cart-recommendations', "&limit=").concat(3, "&product_id=").concat(cartRecomWrapper.dataset.product, "&intent=complementary");
//     fetch(requestUrl).then(function (response) {
//       return response.text();
//     }).then(function (text) {
//       var html = document.createElement("div");
//       html.innerHTML = text;
    
//       console.log(html) 
//       cartRecomWrapper.appendChild(html)

//       const prevButton = document.querySelector('.cart-recommendations .slider-nav-button-prev');
//       const nextButton = document.querySelector('.cart-recommendations .slider-nav-button-next');
//       const slider = document.querySelector('.cart-recommendations .cross-sells__items');

//       prevButton.addEventListener('click', () => {
//         slider.scrollBy({ left: -slider.offsetWidth, behavior: 'smooth' });
//       });

//       nextButton.addEventListener('click', () => {
//         slider.scrollBy({ left: slider.offsetWidth, behavior: 'smooth' });
//       });
//     }).catch(function (error) {
//       throw error;
//     });
//   }
// }
